/** True for middle-click or Ctrl/Cmd+click (open in a new tab). */
export function shouldOpenInNewTab(
  e: Pick<MouseEvent, "button" | "ctrlKey" | "metaKey">,
): boolean {
  return e.button === 1 || e.ctrlKey || e.metaKey;
}

/**
 * Open `href` in a new tab when the gesture asks for it; otherwise return `"same"`
 * so the caller can navigate in-place.
 */
export function navigateOrOpenNewTab(
  href: string,
  e?: Pick<MouseEvent, "button" | "ctrlKey" | "metaKey"> | null,
): "same" | "new" {
  if (e && shouldOpenInNewTab(e)) {
    window.open(href, "_blank", "noopener");
    return "new";
  }
  return "same";
}
